import { createFileRoute } from "@tanstack/react-router";
import { LegalPublicPage } from "@/components/legal/LegalPublicPage";
import { publicSitePath } from "@/lib/public-site";

export const Route = createFileRoute("/cookies")({
  component: CookiesPage,
  head: () => ({
    meta: [{ title: "Política de Cookies — tunegocio" }],
    links: [{ rel: "canonical", href: publicSitePath("/cookies") }],
  }),
});

function CookiesPage() {
  return (
    <LegalPublicPage
      title="Política de Cookies"
      type="cookie_policy"
    />
  );
}
